// extracted by mini-css-extract-plugin
module.exports = {"Hero":"styles_Hero__2E2Gz","Center":"styles_Center__I4Xom","HeroGraduates":"styles_HeroGraduates__2qzIt","Overlay":"styles_Overlay__2mlri"};